/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { FormattedMessage, useIntl } from 'react-intl'
import { useParams } from 'react-router'
import PageTitle from '../../../../client/js/components/PageTitle'
import { fetchProspecting } from '../../lib/rest/prospectingAPIClient'
import ProspectingForm from './ProspectingForm'
import { useQuery } from '@tanstack/react-query'
import LoadingHelper from '../../../../client/js/components/LoadingHelper'
import { Card, Container } from '@mantine/core'
import useQueryParams from '../../../../client/js/hooks/useQueryParams'
import useParsedQueryParam from '../../../../client/js/hooks/useParsedQueryParam'
import { parseNumber } from '@jalik/form-parser'
import Page from '../../../../client/js/components/Page'
import BreadcrumbCard from '../../../../client/js/components/breadcrumb/BreadcrumbCard'
import AnchorLink from '../../../../client/js/components/AnchorLink'
import AdminBreadcrumb from '../../../../client/js/components/breadcrumb/AdminBreadcrumb'
import { getProspectingListLink } from '../../lib/links/prospectingLinks'

function ProspectingFormPage () {
  const intl = useIntl()
  const params = useParams<{ id?: string }>()
  const prospectingId = parseInt(params.id, 10)
  const [searchParams] = useQueryParams()
  const customerId = useParsedQueryParam('customerId', parseNumber)

  const prospectingQuery = useQuery({
    enabled: true,
    queryKey: ['prospecting', prospectingId, searchParams],
    queryFn: () => prospectingId > 0
      ? fetchProspecting(prospectingId)
      : Promise.resolve({
        customerId
      } as Partial<Prospecting>),
    refetchOnWindowFocus: false
  })
  const { data } = prospectingQuery

  const title = prospectingId > 0 && data != null
    ? intl.formatMessage({
      id: 'prospecting_%id',
      defaultMessage: 'Prospection n°{id}'
    }, { id: prospectingId })
    : intl.formatMessage({
      id: 'create_prospecting',
      defaultMessage: 'Créer une prospection'
    })

  return (
    <Page>
      <Container size="xl">
        <PageTitle
          hidden
          title={title}
        />

        <BreadcrumbCard>
          <AdminBreadcrumb>
            <AnchorLink to={getProspectingListLink({ succeeded: 'null' })}>
              <FormattedMessage
                id="prospecting.plural"
                defaultMessage="Prospections"
              />
            </AnchorLink>
            <span>{title}</span>
          </AdminBreadcrumb>
        </BreadcrumbCard>

        <Card shadow="sm">
          <LoadingHelper
            query={prospectingQuery}
            render={() => (
              <ProspectingForm initialValues={data} />
            )}
          />
        </Card>
      </Container>
    </Page>
  )
}

export default ProspectingFormPage
